import React, { useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../../services/api';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51RhYZR4N3NRD17DaFW7M17PFyliGDuPSD2wOxjDLS1NS1jQYk5J0tyELmtu1YawnIMQB1IoEZBS7QQPXh09tsHjv00SfIi8hhu');

const StripePayment = ({ bookingData }) => {
  useEffect(() => {
    redirectToCheckout();
  }, []);

  const redirectToCheckout = async () => {
    try {
      localStorage.setItem('bookingConfirmation', JSON.stringify(bookingData));
      
      // Get current frontend URL
      const currentUrl = window.location.origin;
      console.log('📍 Current frontend URL:', currentUrl);
      
      const response = await api.post('/payment/create-checkout-session', {
        amount: bookingData.totalAmount,
        bookingId: bookingData.bookingId,
        userEmail: bookingData.userEmail || 'customer@example.com',
        movieTitle: bookingData.movieTitle || 'Movie Ticket',
        seats: bookingData.seats || [],
        showId: bookingData.showId,
        seatDetails: bookingData.seatDetails,
        theaterName: bookingData.theaterName,
        showDate: bookingData.showDate,
        showTime: bookingData.showTime,
        moviePoster: bookingData.moviePoster,
        frontendUrl: currentUrl  // Send current frontend URL explicitly
      });
      
      const { url } = response.data;
      window.location.href = url;
    } catch (error) {
      console.error('Checkout error:', error);
      toast.error('Payment setup failed. Please try again.');
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
      <div className="text-center">
        <Spinner animation="border" role="status" className="mb-3" />
        <p className="text-white">Redirecting to Stripe Checkout...</p>
      </div>
    </div>
  );
};

export default StripePayment;
